import { styled } from "@mui/material/styles";

const spanDefault = {
  fontFamily: "Manrope",
  fontSize: 16,
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: 0.5,
};

export const Wrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: 8,
}));

export const Message = styled("span")(() => ({
  color: "#232325",
  ...spanDefault,
}));

export const WarningMessage = styled("span")(() => ({
  color: "#D92D20",
  ...spanDefault,
}));
